import React, { Component } from 'react';
import AuthService from '../../utils/AuthService';
import DashboardDealer from '../DashboardDealer';
import DashboardSales from '../DashboardSales';
import DashboardAdmin from '../DashboardAdmin';

var Auth = new AuthService();

// Auth logic with routes from this example:
// https://reacttraining.com/react-router/web/example/auth-workflow
class Dashboard extends Component {
	constructor(props) {
		super(props);

		this.Auth = new AuthService();
		this.user = Auth.getProfile();

		switch (this.user.pp_role_name) {
			case 'Dealer':
				this.dashboard = <DashboardDealer />;
				break;
			case 'Internal':
			case 'Sales':
				this.dashboard = <DashboardSales />;
				break;
			case 'Admin':
				this.dashboard = <DashboardAdmin />;
				break;
		}
	}

	render() {

		return (
			<div>{this.dashboard}</div>
		);
	}
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard.js